import React from 'react'

export default props => {
  const handlePropagation = e => {
    e.stopPropagation()
  }
  return <div style={{display: 'flex'}} onClick={handlePropagation} onKeyDown={handlePropagation}> 
    {props.children}
    </div>
}